import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrowdown-16-px_cabd252e67cab54ba39c9837404a662c",
  "use": "arrowdown-16-px_cabd252e67cab54ba39c9837404a662c-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrowdown-16-px_cabd252e67cab54ba39c9837404a662c\">\n    <path fill-rule=\"nonzero\" d=\"M8 9.062L12.735 4.5 14 5.719 8 11.5 2 5.719 3.265 4.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol